@if (tmIconType === 'basic-tick') {
  <tg-icon
    name="basic-tick"
    role="presentation"
    >
  </tg-icon>
}
@if (tmIconType === 'basic-arrow-right') {
  <tg-icon
    name="basic-arrow-right"
    role="presentation"
    >
  </tg-icon>
}
